import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
    home: { type: Boolean, default: false },
  },
  setup(__props) {

const props = __props

  // eslint-disable-next-line no-undef
  

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (props.home)
    ? (_openBlock(), _createBlock(_component_q_btn, {
        key: 0,
        flat: "",
        dense: "",
        round: "",
        to: "/",
        replace: "",
        "aria-label": "Back Link",
        icon: "fas fa-chevron-left"
      }))
    : (_openBlock(), _createBlock(_component_q_btn, {
        key: 1,
        flat: "",
        dense: "",
        round: "",
        onClick: _ctx.$router.back,
        "aria-label": "Back Link",
        icon: "fas fa-chevron-left"
      }, null, 8, ["onClick"]))
}
}

})